import React from 'react';
import styled from 'styled-components';

import { Tabs } from '@lt/components';

import { SEARCH_TYPES } from './constants';
import { SEARCH_TYPE_NAMES } from '../Cigarette/constants';

import { SearchTypeTab } from './SearchTypeTab';

import type { TabsVariant } from './types';
import type { SearchType } from '../Cigarette/types';

export interface SearchTypeTabsProps {
  selectedTab: SearchType;
  variant: TabsVariant;
  setSelectedTab: React.Dispatch<React.SetStateAction<SearchType>> | React.Dispatch<SearchType>;
  className?: string;
  availableSearchTypes?: string[];
}

const SearchTypeTabs = (props: SearchTypeTabsProps): JSX.Element => {
  const {
    selectedTab = SEARCH_TYPE_NAMES.PACKAGE,
    setSelectedTab,
    variant,
    className,
    availableSearchTypes,
  } = props;

  const searchTypesArray = availableSearchTypes
    ? SEARCH_TYPES.filter(({ name }) => availableSearchTypes.includes(name))
    : SEARCH_TYPES;

  return (
    <StyledTabs functional onChange={setSelectedTab} $variant={variant} className={className}>
      {searchTypesArray.map((searchTypeInfo) => (
        <SearchTypeTab
          key={searchTypeInfo.name}
          isActive={selectedTab === searchTypeInfo.name}
          {...props}
          {...searchTypeInfo}
        />
      ))}
    </StyledTabs>
  );
};

const StyledTabs = styled(Tabs)<{
  $variant: TabsVariant;
}>`
  display: flex;
  justify-content: ${({ $variant: { mobile, page } }) =>
    mobile && page === 'OLD_MAIN' ? 'center' : 'flex-start'};
  height: ${({ $variant: { mobile, collapsed } }) => {
    if (!mobile) return '48';
    return collapsed ? '20' : '40';
  }}px;
  // стили LTWidgetRoot перекрываются
  margin-left: 8px !important;
`;

export default SearchTypeTabs;
